import { memo, useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isWidgetDisplayed } from "../../../../../esri/widgets/expandUtils";
import { useFiltersFetch } from "../../../../../hooks";
import useLayersChange from "../../../../../hooks/useLayersChange";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { getVisibleFilters } from "../../../../../utils/helper";
import { FilterIcon } from "../../../../Icons";
import MobileFilter from "../../../../MobileApp/MobileFilter/MobileFilter";
import { Modal } from "../../../../UI";
import { StyledFilterModalContainer } from "../Sidebar-styled";
import Section from "../UI/Section/Section";
import FiltersCount from "./FiltersCount";

const SectionFilters = ({ expanded }) => {
  const [show, setShow] = useState(false);

  const view = useSelector((state) => state.mapViewReducer.view);
  const filters = useSelector((state) => state.filters);
  const activeModule = useSelector((state) => state.activeModule);

  const { config } = useContext(ConfigContext);
  const { fieldsValueCountMap, fieldsRelationsMap, fieldsLayers } =
    useFiltersFetch(config);

  const { t } = useTranslation("common");
  const { layerCount } = useLayersChange(config);

  const hasFilterWidget = useMemo(() => {
    if (!view) return false;
    return isWidgetDisplayed(config, "Filter");
  }, [config, view]);

  const hasFilters = useMemo(() => {
    if (!view) return false;
    const visibleFilters = getVisibleFilters(config, activeModule, filters);
    return Object.keys(visibleFilters).length > 0;
  }, [config, filters, activeModule, layerCount, view]);

  const initialFilters = useMemo(() => filters, []);

  if (!hasFilterWidget) return null;

  return (
    <>
      <Section
        expanded={expanded}
        title={t("screen.widget.Filter.title")}
        information={t("screen.widget.Filter.information")}
        Icon={FilterIcon}
        TrailingComponent={() => <FiltersCount expanded={expanded} />}
        className="onboarding-filter"
        widgetName="Filter"
        isSelected={show}
        setIsSelected={setShow}
        disabled={!hasFilters}
      />
      <Modal show={show}>
        <StyledFilterModalContainer>
          <MobileFilter
            isMobile={false}
            showFilters={true}
            setShowFilters={setShow}
            menuPosition="absolute"
            initialFilters={initialFilters}
            fieldsValueCountMap={fieldsValueCountMap}
            fieldsRelationsMap={fieldsRelationsMap}
            fieldsLayers={fieldsLayers}
          />
        </StyledFilterModalContainer>
      </Modal>
    </>
  );
};

export default memo(SectionFilters);
